import { Atom } from "effect/unstable/reactivity";

import { appAtomRegistry } from "../rpc/atomRegistry";

/**
 * Where this client stands on finding its primary Environment. The primary joins the catalog
 * only once its Environment Service answers, so until then an empty catalog cannot tell "no
 * Environments" from "the one this client has is not answering".
 *
 * - `searching`: asking, or about to.
 * - `unreachable`: the last search ran out of retries; a reconnect or wake asks again.
 * - `settled`: found, or this client has no primary Environment to find.
 */
export type PrimaryEnvironmentDiscovery = "searching" | "unreachable" | "settled";

export const primaryEnvironmentDiscoveryAtom = Atom.make<PrimaryEnvironmentDiscovery>(
  "searching",
).pipe(Atom.keepAlive, Atom.withLabel("primary-environment-discovery"));

export function setPrimaryEnvironmentDiscovery(discovery: PrimaryEnvironmentDiscovery) {
  appAtomRegistry.set(primaryEnvironmentDiscoveryAtom, discovery);
}
